<template>
  <div class="ub-fl selected-device">
    <h1 class="title">
      {{ $t('crm_deliver_goods_deliver.fa_huo_biao') }}
    </h1>
    <div class="box">
      <div class="search-hd">
        <el-select
          v-model="productCodes"
          :multiple="true"
          collapse-tags
          style="width: 230px; float: left;"
        >
          <el-option
            v-for="(item,index) in selData"
            :key="index"
            :label="item.productCode"
            :value="item.productCode"
          ></el-option>
        </el-select>
        <el-input
          clearable
          v-model="formSearch.keyword"
          style="float: right; width: 180px;"
          :placeholder="$t('crm_deliver_goods_deliver.ji_shen_hao')"
        ></el-input>
      </div>
      <div>
        <custom-table
          v-model="deviceOut"
          :data="selectedData"
          tableCode="deliver_goods_dialog_list"
          height="500px"
          ref="tb2"
          type="checkbox"
          @filter="filterChange"
          @sort="sortChange"
        ></custom-table>
      </div>
    </div>
  </div>
</template>

<script>
/** 发货表 */

export default {
  props: {
    needDevices: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  watch: {
    needDevices: {
      immediate: true,
      handler(val) {
        if (val && val.length) {
          this.initSelData();
        }
      }
    }
  },
  data() {
    return {
      tableCode: 'product_import_device',
      formSearch: {
        keyword: '',
        productSn: ''
      },
      deviceOut: [],
      selectedDevice: [],
      selData: [],
      productCodes: []
    };
  },
  computed: {
    selectedData() {
      const list = this.selectedDevice.filter(item => item.bodyNum.includes(this.formSearch.keyword)
      );

      if (this.productCodes.length) {
        return list.filter(item => this.productCodes.includes(item.productCode));
      }

      return list;
    }
  },
  methods: {
    initSelData() {
      const record = [];
      const ret = [];
      this.needDevices.forEach((item) => {
        if (!record.includes(item.productCode)) {
          ret.push(item);
          record.push(item.productCode);
        }
      });
      this.selData = ret;
    },
    onGetList() {},
    addDevice(deviceIn) {
      deviceIn.forEach((item) => {
        const has = this.selectedDevice.find(
          t => t.deviceId === item.deviceId
        );
        if (!has) {
          this.selectedDevice.push(item);
        }
      });
    },
    removeDevice() {
      this.deviceOut.forEach((item) => {
        this.selectedDevice = this.selectedDevice.filter(
          t => t.deviceId !== item.deviceId
        );
      });
    },
    getSelectedDevice() {
      return this.selectedDevice;
    }
  },
  mounted() {
    this.getTableColumn();
  }
};
</script>

<style></style>
